import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCurDate, getDateString } from "../utils/DateTimeUtils";

const initialState = {
    workDate: getDateString(getCurDate()),
    lotteryActive: undefined,
    error: null,
    editingMessage: undefined, // trong trường hợp edit tin nhắn !=undefined, các trường hợp khác = undefined
    lastSyncDate: 0,// thời gian lớn nhất của tin telegram đồng bộ từ sv về
    chats: [] // danh sách chat tải từ sv về
}

export const globalSlice = createSlice({
    name: "global",
    initialState,
    //Khai báo các action bên trong reducers, các action để làm thay đổi state khi dispatch
    reducers: {
        updateWorkDate: (state, action) => {
            const { workDate } = action.payload
            state.workDate = workDate
        },
        updateLotteryActive: (state, action) => {
            const { lotteryActive } = action.payload
            state.lotteryActive = lotteryActive
        },
        setError: (state, action) => {
            state.error = action.payload
            //console.error(action.payload)

        },
        updateEditedMessageId: (state, action) => {
            const { editingMessage } = action.payload
            state.editingMessage = editingMessage
            //console.log('state.edittedMessageId=',editedMessageId)
        },
        updateBotChats: (state, action) => {
            const { chats } = action.payload
            state.chats = chats
            //console.log('state.chats=',chats)
        },
        updateLastDate: (state, action) => {
            const { lastDate } = action.payload
            state.lastSyncDate = lastDate
            //console.log('state.edittedMessageId=',editedMessageId)
        },
    },
    extraReducers: (builder) => {

    },
});

export const { updateWorkDate, updateLotteryActive, setError, updateEditedMessageId, updateBotChats,
    updateLastDate
} = globalSlice.actions;
export default globalSlice.reducer;